<div class="flex-center py-6">
  <div class="narrow-card-container">
    <div class="card">
      <div class="card-body p-4 p-sm-5">
        <div class="row flex-between-center mb-2">
          <div class="col-auto">
            <h5>{{ "general.logIn" | translate }}</h5>
          </div>
          <div class="col-auto fs-10 text-600">
            <span class="mx-1 undefined">{{ "general.or" | translate }}</span>
            <span
              ><a href="#/auth/registration">{{
                "general.register" | translate
              }}</a></span
            >
          </div>
        </div>
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <div class="mb-3">
            <app-validated-input
              label="general.emailAddress"
              inputFormControlName="email"
              [inputFormControl]="$any(loginForm.controls['email'])"
              type="email"
              [validationTrainslations]="{
                required: 'login.emailIsRequired',
                email: 'login.wrongEmailFormat'
              }"
            />
          </div>

          <div class="mb-3">
            <app-validated-input
              label="general.password"
              inputFormControlName="password"
              [inputFormControl]="$any(loginForm.controls['password'])"
              type="password"
              [validationTrainslations]="{
                required: 'login.passwordIsRequired'
              }"
            />
          </div>
          <div class="row flex-between-center">
            <div class="col-auto">
              <app-validated-checkbox
                label="login.rememberMe"
                inputFormControlName="rememberMe"
                [inputFormControl]="$any(loginForm.controls['rememberMe'])"
                [dense]="true"
              />
            </div>
            <div class="col-auto">
              <a class="fs-10" href="#/auth/forgot-password">{{
                "general.forgottenPassword" | translate
              }}</a>
            </div>
          </div>
          <div class="mb-3">
            <button
              class="btn btn-primary d-block w-100 mt-3"
              type="submit"
              name="submit"
            >
              {{ "general.logIn" | translate }}
            </button>
          </div>
        </form>
        <!--div class="position-relative mt-4">
          <hr />
          <div class="divider-content-center">
            {{ "login.logInDifferentWay" | translate }}
          </div>
        </div>
        <div class="row g-2 mt-2">
          <div class="col-sm-6">
            <a class="btn btn-outline-google-plus btn-sm d-block w-100" href="#"
              ><span
                class="fab fa-google-plus-g me-2"
                data-fa-transform="grow-8"
              ></span>
              {{ "general.google" | translate }}</a
            >
          </div>
          <div class="col-sm-6">
            <a class="btn btn-outline-facebook btn-sm d-block w-100" href="#"
              ><span
                class="fab fa-facebook-square me-2"
                data-fa-transform="grow-8"
              ></span>
              {{ "general.facebook" | translate }}</a
            >
          </div>
        </div-->
      </div>
    </div>
  </div>
</div>
